import { useEffect, useState } from "react";
import { getSearchAlbumList } from "../../actions/user";
import TableCard, { CardData as TableCardData, headerItem } from '../../components/cards/TableCard';
import { Pagination } from "../../components/pagination";
import SearchRelease from "../../components/search-forms/searchRelease";
import { Actions, friendlyDate } from "../../utils";
import { COOKIE_PARAMS, GLOBAL_URLS } from "../../constants";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router";

const ReleasesPage = () => {
    const { user } = useAuth() as any;
    const [tableData, setTableData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [timer, setTimer] = useState<any>();
    const DefaultLabels = window.localStorage.getItem(COOKIE_PARAMS.SELECTED.LABEL) ? window.localStorage.getItem(COOKIE_PARAMS.SELECTED.LABEL)?.split(',') : [];
    window.localStorage.removeItem(COOKIE_PARAMS.SELECTED.LABEL);
    const naviagte = useNavigate()
    const [formData, setFormData] = useState<any>({
        pagination: {
            page: 0,
            pages: 0,
            size: 10,
            total: 0
        },
        filter: {
            keyword: "",
            client: [2],
            label: DefaultLabels,
            type: [],
        }
    });

    const [resData, setResData] = useState<any>({
        pagination: {
            page: 0,
            pages: 0,
            size: 10,
            total: 0
        },
        title: "",
        list: [],
        filtered: {
            client: [],
            label: [],
            type: [],
        }
    });

    useEffect(() => {
        let filter = {
            client: user.client?.id ? [user.client.id] : [2],
            keyword: formData.filter.keyword,
            label: formData.filter.label,
            type: formData.filter.type,
        };
        setFormData({ ...formData, filter: filter });
    }, [user.client])

    const loadData = () => {
        setLoading(true);
        setResData({
            ...resData,
            pagination: {
                ...resData.pagination,
                pages: 0,
            },
            title: '',
        });
        getSearchAlbumList(formData).then((res: any) => {
            setLoading(false);
            setResData({
                ...res.result,
                title: `found ${res.result.pagination.total.toLocaleString().toString().replace(/,/g, ', ')} results`,
            });
            const result: TableCardData[] = [];
            for (let i = 0; i < res.result.list.length; i++) {
                result.push({
                    id: res.result.list[i].id,
                    icon: `https://img.cugate.com/?i=${res.result.list[i].id}&o=album`,
                    data: [
                        {
                            type: `icon`,
                        },
                        // {
                        //     cell: res.result.filtered.type.filter((c:any)=>c.id===res.result.list[i].type_id).length?
                        //     res.result.filtered.type.filter((c:any)=>c.id===res.result.list[i].type_id)[0].title:'',
                        // },
                        {
                            title: `<a onclick='window.open("${GLOBAL_URLS.RELEASE_DETAIL_URL + res.result.list[i].id}");'>${res.result.list[i].title}</a>`,
                            cell: res.result.list[i].members.length ? res.result.list[i].members.map((m: any) => `<a onclick='window.open("${GLOBAL_URLS.MEMBER_DETAIL_URL + m.id}");'>${m.title}</a>`).join(", ") : '',
                        },
                        {
                            cell: res.result.list[i].label?.long_title,
                        },
                        {
                            cell: res.result.list[i].track_count
                        },
                        {
                            cell: res.result.list[i].catalogue_num,
                        },
                        {
                            cell: friendlyDate(res.result.list[i].register_date),
                        },
                        {
                            cell: friendlyDate(res.result.list[i].update_time),
                        },
                    ]
                })
            }
            setTableData(result);
        });
    };

    useEffect(() => {
        clearTimeout(timer);
        setTimer(setTimeout(
            () => {
                loadData()
            }, 500
        ));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);

    const handleReleaseEditAction = (id: number) => {
        // naviagte(`${GLOBAL_URLS.RELEASE_EDIT_URL}/${id}`)
        window.open(GLOBAL_URLS.RELEASE_EDIT_URL + id)
    };

    const handleReleaseDeleteAction = (id: number) => {

    };
    const handleReleaseDuplicateAction = (id: number) => {
        window.open(GLOBAL_URLS.RELEASE_DUPLICATE_URL + id)
    };

    const handleClient = (client: number) => {
        let list = [];
        formData.filter.client.forEach((g: number) => {
            if (client !== g) list.push(g);
        });
        if (!formData.filter.client.filter((g: number) => g === client).length) {
            list.push(client);
        }
        setFormData({
            pagination: {
                ...formData.pagination,
                page: 0,
            },
            filter: {
                ...formData.filter,
                client: list
            }
        });
    };

    const handleLabel = (label: number) => {
        let list = [];
        formData.filter.label.forEach((g: number) => {
            if (label !== g) list.push(g);
        });
        if (!formData.filter.label.filter((g: number) => g === label).length) {
            list.push(label);
        }
        setFormData({
            pagination: {
                ...formData.pagination,
                page: 0,
            },
            filter: {
                ...formData.filter,
                label: list
            }
        });
    };

    const handleType = (type: number) => {
        let list = [];
        formData.filter.type.forEach((g: number) => {
            if (type !== g) list.push(g);
        });
        if (!formData.filter.type.filter((g: number) => g === type).length) {
            list.push(type);
        }
        setFormData({
            pagination: {
                ...formData.pagination,
                page: 0,
            },
            filter: {
                ...formData.filter,
                type: list
            }
        });
    };

    const handleKeyword = (e: any) => {
        setFormData({
            pagination: {
                ...formData.pagination,
                page: 0,
            },
            filter: {
                ...formData.filter,
                keyword: e.target.value
            }
        });
    }

    const handlePage = (page: number) => {
        setFormData({
            ...formData,
            pagination: {
                ...formData.pagination,
                page: page,
            }
        });
    };

    return (
        <div className="page page-label mb-5">
            <SearchRelease
                data={{
                    client: formData.filter.client,
                    label: formData.filter.label,
                    type: formData.filter.type,
                    clientList: resData.filtered.client,
                    labelList: resData.filtered.label,
                    typeList: resData.filtered.type,
                    handleClient: handleClient,
                    handleLabel: handleLabel,
                    handleType: handleType,
                }}
            />
            <div className="">
                <div className="uk-container-large">
                    <div className="search-component search-form">
                        <div className="container uk-container-large">
                            <div className="bg-white border border-white rounded d-flex justify-content-between align-items-center">
                                <input
                                    placeholder="Search releases"
                                    className="border border-white form-control search-track-input"
                                    onChange={handleKeyword}
                                    value={formData.filter.keyword}
                                />
                                <img
                                    src="/imgs/search.svg"
                                    className="me-2 py-2 focus"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>
                    <TableCard
                        title={resData.title}
                        loading={loading}
                        danger={true}
                        icon={false}
                        filterable={false}
                        className={`member-table tb-valign-top w-100`}
                        actions={[Actions.edit, Actions.delete, Actions.duplicate]}
                        data={tableData}
                        headers={[
                            headerItem("", '64px'),
                            // headerItem("Type", '68px'),
                            headerItem("Title/Artist"),
                            headerItem("Label"),
                            headerItem("# of Tracks", '106px'),
                            headerItem("Cat. Number", '120px'),
                            headerItem("Created At", '110px'),
                            headerItem("Updated At", '110px'),
                        ]}
                        onClickEdit={handleReleaseEditAction}
                        onClickDelete={handleReleaseDeleteAction}
                        onClickPlus={handleReleaseDuplicateAction}
                    />
                    <Pagination
                        pagination={resData.pagination}
                        handlePage={handlePage}
                        className={"mt-4"}
                    />
                </div>
            </div>
        </div>
    )
}

export default ReleasesPage;